import styled from "@emotion/styled"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"

export const AnimWrapper = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex: 1 1 0%;
  align-items: flex-start;
  justify-content: center;

  object-fit: contain;
  padding: 0 16px;
  ${(props) => `${props.noPadding ? "padding: 0;" : ""}`}

  opacity: 0;
  visibility: hidden;

  &.AnimWrapperStandalone {
    opacity: 1;
    visibility: visible;
  }

  ${queries.large`
    align-items: center;
  `}
`

export const AnimSvg = styled.svg`
  width: 100%;
  height: 100%;
  color: white;

  text-transform: uppercase;
  letter-spacing: 0.06em;

  ${queries.large`
    height: 80%;
  `}

  & text {
    font: 12px monospace;
    font: 12px "Andale Mono";
    font: 12px "Dinamo Semi Mono";

    ${queries.medium`
      font: 14px monospace;
      font: 14px "Andale Mono";
      font: 14px "Dinamo Semi Mono";
    `}
  }
`

export const AnimSvgSimple = styled.svg`
  width: 100%;
  height: 100%;
  color: white;

  text-transform: uppercase;
  letter-spacing: 0.06em;
  max-width: 472px;

  ${queries.large`
    height: 450px;
     max-width: none;
  `}

  & text {
    font: 12px monospace;
    font: 12px "Andale Mono";
    font: 12px "Dinamo Semi Mono";

    ${queries.medium`
      font: 14px monospace;
      font: 14px "Andale Mono";
      font: 14px "Dinamo Semi Mono";
    `}
  }
`

AnimSvg.defaultProps = { preserveAspectRatio: "xMidYMid meet" }
